<script>
    import * as VueGoogleMaps from 'vue2-google-maps';
    import vSelect from 'vue-select';
    import {Form} from '../../../helpers/Form/Form';
    import StarRating from 'vue-star-rating';
    import CourseSmartModal from '../../course/CourseSmartModal'

    if (window.googleMapsAPI) {
        Vue.use(VueGoogleMaps, {
            load: {
                key: window.googleMapsAPI,
                libraries: 'places',
            }
        });
    }

    export default {
        components: {
            'vue-google-autocomplete': VueGoogleMaps.Autocomplete,
            'google-map': VueGoogleMaps.Map,
            'google-marker': VueGoogleMaps.Marker,
            'v-select': vSelect,
            StarRating,
            CourseSmartModal
        },
        name: "MyCourses",
        props: {
            'coursesprop': Array,
            'sportsprop': {},
            'company': {},
            'companies': null
        },
        data() {
            return {
                form: new Form({}),
                modalShow: false,
                duplicationModalShow: false,
                //temp variables until we got number of participants
                value: 65,
                max: 100,
                filterSport: null,
                types: ['geocode'],
                ages: [
                    '0 - 5 anni',
                    '6 - 11 anni',
                    '12 - 17 anni',
                    '18 - 26 anni',
                    '27+ anni'
                ],
                filterAge: null,
                actualAge: null,
                sports: null,
                duplicatedCourse: {
                    'company': null,
                    'sport': null,
                    'name': '',
                },
                sport_search_string: '',
                sport_loading: null,
                courses: null,
                duplicating_course: {}
            }
        },
        created() {
            this.sports = this.sportsprop;
            this.courses = this.coursesprop;
        },
        mounted() {
            $("#course-smart-modal").modal({
                show: false,
                backdrop: 'static',
                escape: false
            })

            let modal = this.getParameterByName('modal')
            if (!_.isEmpty(modal)) {
                this.$bus.$emit('course-modal.show', {
                    company: this.company
                })

                $(`#${modal}`).modal('show')
            }

            let self = this;
            this.search(this.sport_loading, this.sport_search_string, this);
            $('#selectSport').select2();
            this.$bus.$on('delete-course', this.removeCourse);

            this.$bus.$on('open-duplicate-modal', function (course) {
                self.duplicating_course = course;
                $("#duplicate_modal").modal('show');
                $('#select_sport_duplicating_modal').select2();
                $('.pac-container').css("z-index", 2000);
            })

            this.$bus.$on('course.created', this.updateCourses)
            this.$bus.$on('course.updated', this.updateCourse)
        },
        computed: {
            count_promoted_courses() {
                return this.promoted_courses.length;
            },
            count_active_courses() {
                return this.active_courses.length;
            },
            count_inactive_courses() {
                return this.inactive_courses.length;
            },
            promoted_courses() {
                return this.courses.filter(function (course) {
                    return course.is_promoted
                });
            },
            active_courses() {
                return this.courses.filter(function (course) {
                    return course.is_active
                });
            },
            inactive_courses() {
                return this.courses.filter(function (course) {
                    return !course.is_active
                });
            },
            center() {
                if (this.course.latitude && this.course.longitude) {
                    return {
                        lat: this.course.latitude,
                        lng: this.course.longitude
                    }
                }
            },
            activeDays() {
                let activeDays = [];
                this.courses.forEach((course, index) => {
                    activeDays[index] = [
                        {
                            shortName: 'L',
                            isActive: false
                        }, {
                            shortName: 'M',
                            isActive: false
                        }, {
                            shortName: 'M',
                            isActive: false
                        }, {
                            shortName: 'G',
                            isActive: false
                        }, {
                            shortName: 'V',
                            isActive: false
                        }, {
                            shortName: 'S',
                            isActive: false
                        }, {
                            shortName: 'D',
                            isActive: false
                        }
                    ],
                        course.days.forEach((day) => {
                            if (day.day == 'Lunedì') {
                                activeDays[index][0].isActive = true;
                            }
                            if (day.day == 'Martedì') {
                                activeDays[index][1].isActive = true;
                            }
                            if (day.day == 'Mercoledì') {
                                activeDays[index][2].isActive = true;
                            }
                            if (day.day == 'Giovedì') {
                                activeDays[index][3].isActive = true;
                            }
                            if (day.day == 'Venerdì') {
                                activeDays[index][4].isActive = true;
                            }
                            if (day.day == 'Sabato') {
                                activeDays[index][5].isActive = true;
                            }
                            if (day.day == 'Domenica') {
                                activeDays[index][6].isActive = true;
                            }
                        });
                });
                return activeDays;
            }
        },
        methods: {
            onShowSmartModal() {
                this.$bus.$emit('course-modal.show', {
                    company: this.company
                })
                
                $("#course-smart-modal").modal('show')
            },  
            getParameterByName(name, url) {
                if (!url) url = window.location.href;
                name = name.replace(/[\[\]]/g, "\\$&");

                var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);

                if (!results) return null;
                if (!results[2]) return "";

                return decodeURIComponent(results[2].replace(/\+/g, " "));
            },            
            updateCourses({course}) {
                this.courses.push(course)
            },
            updateCourse({course}) {
                let idx = _.findIndex(this.courses, i => i.id == course.id)
                this.$set(this.courses, idx, course)
            },
            onChosen(course) {
                console.log('ciao');
                $('#chooseCourseModal').modal('hide');
                /*$('#coursePromotion').css('overflow-y','auto');*/
                location.href = "/corsi/" + course.slug + "/create-promotion";
                this.onPromotion(course);
            },
            removeCourse(course) {
                if (this.courses && course) {
                    this.courses.splice(this.courses.indexOf(course), 1);
                }

            },
            onDisablePromotion(course) {
                this.form
                    .submit('put', `${window.baseUrl}/corsi/${course.slug}/update-promotion`)
                    .then(response => location.reload())
            },
            onPromotion(course) {
                this.$bus.$emit('update-promotion', course)
            },
            onSearch(search, loading) {
                this.sport_search_string = search;
                this.sport_loading = loading;
            },
            search: _.debounce((loading, search, vm) => {
                axios({
                    method: 'get',
                    url: '/sports/search?q=' + search
                }).then((response) => {
                    vm.sports = response.data.sports;
                    loading(false);
                }).catch((error) => {
                    vm.message = 'Error';
                });
            }),
            getSport(sportId) {
                var self = this;

                axios({
                    method: 'get',
                    url: '/sports/' + sportId
                }).then((response) => {
                    this.sport = response.data.sport;

                }).catch((error) => {
                    self.message = 'Error';
                });
            },
            filterBySport(sport) {
                this.filterSport = sport;
            },
            filterByAge(age) {
                this.actualAge = age;
                switch (age) {
                    case '0 - 5 anni':
                        this.filterAge = [0, 5];
                        break;
                    case '6 - 11 anni':
                        this.filterAge = [6, 11];
                        break;
                    case '12 - 17 anni':
                        this.filterAge = [12, 17];
                        break;
                    case '18 - 26 anni':
                        this.filterAge = [18, 26];
                        break;
                    case '27+ anni':
                        this.filterAge = [27, 100];
                        break;
                }
            },
            hiddenCourse(course) {

                var state = 'hidden';
                if (this.filterAge == null || (this.filterAge[0] <= course.start_age && this.filterAge[1] >= course.end_age)) {
                    state = '';
                }
                if (this.filterSport != null && this.filterSport.id != course.sport.id) {
                    state = 'hidden'
                }
                return state;
            },
            formatDate(date) {
                return moment(date).format('DD/MM/YYYY')
            },
            clearSportFilter() {
                this.filterSport = null;
            },
            clearAgeFilter() {
                this.actualAge = 'Tutte le età';
                this.filterAge = null;
            },
            createCourse() {
                window.location.href = '/corsi/create/?company=' + this.company.slug;
            },
            getDayClass(day) {
                if (day.isActive) {
                    return 'company-day company-day-active';
                }
                else
                    return ''
            },
            edit(slug) {
                window.location.href = '/corsi/' + slug + '/edit';

            },
            getActiveCourseCheckboxId(id) {
                return 'active-course-checkbox' + id
            },

            duplicateIn(courseId) {
                var self = this;

                axios({
                    method: 'post',
                    url: '/courses/' + courseId + '/duplicateIn/' + self.duplicatedCourse.company,
                    data: {
                        duplicatedCourse: self.duplicatedCourse
                    }
                }).then((response) => {
                    if (self.duplicatedCourse.company == self.company.id) {
                        this.courses.push(response.data.course);
                    }
                    $('#duplicate_modal').modal('hide');
                    window.alerts.success('Corso duplicato correttamente');
                }).catch((error) => {
                    window.alerts.error('Operazione fallita');
                });
            },
            duplicate(courseId) {
                let self = this;

                axios({
                    method: 'post',
                    url: '/courses/' + courseId + '/duplicate',
                    data: {
                        duplicatedCourse: self.duplicatedCourse
                    }
                }).then((response) => {
                    self.courses.push(response.data.course);
                    $('#duplicate_modal').modal('hide');
                    window.alerts.success('Corso duplicato correttamente');
                }).catch((error) => {
                    window.alerts.error('Operazione Fallita');
                });
            },
            buildCourseUrl(course) {
                return `/corsi/${course.slug}`;
            },
            buildCoursePromotionUrl(course) {
                return `/corsi/${course.slug}/avvicinamento`;
            },
            goToPromotedCourses() {
                return window.location.href = '/societa-sportive/' + this.company.slug + '/dashboard' + '/inviti-allo-sport'
            },
            goToCourses() {
                return window.location.href = '/societa-sportive/' + this.company.slug + '/dashboard' + '/corsi'
            },
            triggerPlaceChanged() {
                const el = this.$refs.addressComponent.$refs.input;
                el.focus();
                const ev = new Event('keydown');
                ev.which = 40;
                ev.keyCode = 40;
                el.dispatchEvent(ev);

            },
            getAddressData(payload) {
                console.log(payload);
                this.duplicatedCourse.address = payload.formatted_address;
                this.duplicatedCourse.addressComponents = payload.address_components;
                this.duplicatedCourse.latitude = payload.geometry.location.lat();
                this.duplicatedCourse.longitude = payload.geometry.location.lng();
            },
        },
        directives: {
            selectsport: {
                twoWay: true,
                bind:

                    function (el, binding, vnode) {
                        $(el).select2()
                            .on("select2:select", function (e) {
                                vnode.context.duplicatedCourse.sport = $(el).val();
                            }.bind(this));
                    }

                ,
                update: function (el) {
                    $(el).trigger("change");
                }
            }
            ,
        }
        ,
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/company/dashboard/MyCourses.vue